import React from "react";
import CompanyBasedBillableListing from "@/modules/reports/billables/status/company-listing";
import ContractedBillablesFilters from "@/modules/reports/billables/status/all/filters";
import CommonTable from "components/list/table";
import {
  getChildData,
  getChildColumns,
  getBillableFiltersFromCompanyFilters,
} from "@/modules/reports/billables/status/child-table-config";
import { StatsSection } from "@/modules/reports/billables/status/components/stats-section";
import { useState } from "react";

const AllBillables = () => {
  const [filters, setFilters] = useState({});



  return (
    <div>
      <CompanyBasedBillableListing
        title="All"
        filters={ContractedBillablesFilters}
        sortOrder="asc"
        sortBy="name"
        enableAccordion={true}
        onFiltersChange={setFilters}
        renderExpandedRow={(row) => (
          <div className="border rounded-md overflow-hidden bg-background">
            <CommonTable
              data={getChildData(row, "all")}
              columns={getChildColumns("all")}
              showHeader={true}
            />
          </div>
        )}
        renderContent={() => (
          <StatsSection
            status="all"
            filters={getBillableFiltersFromCompanyFilters(filters)}
          />
        )}
      // statusWiseFilters={{ contacts: { projects: { status: { _eq: "active" } } } }}
      />
    </div>
  );
};

export default AllBillables;
